export default {
  text: {
    en: `Be the first to find out about exclusive offers, new products and more!`,
  },
}
